var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 11.332V12.6654C2.6665 13.4017 3.26346 13.9987 3.99984 13.9987H11.9998C12.7362 13.9987 13.3332 13.4017 13.3332 12.6654V11.332",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 6.0013L7.99984 2.66797L11.3332 6.0013",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 2.66797V10.668",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadWhite);
export default __webpack_public_path__ + "static/media/upload-white.0cf9c55efba738bdba90068ebe21dd22.svg";
export { ForwardRef as ReactComponent };